@if (control) {
  <label id="{{id}}_label"
    for='{{id}}_input'
    [ngClass]="{'visually-hidden' : !label }">
    @if (label) {
      <span>
        {{ label | translate }}
        @if (required) {
          <a>*</a>
        }
      </span>
    } @else {
      Bitte geben Sie ein Datum an
    }
    @if (hinweis) {
      <wba-fragezeichen
        label="{{label ? label : 'Eingabefeld'}}"
        [dataTarget]="hinweis?.target"
        [dataModal]="hinweis?.modal"
        id="{{id}}_fragezeichen"
        smaller="true"/>
    }
  </label>
  <input id="{{id}}_input"
    #input
    [title]="title + ' (' + placeholder + ')'"
    type="text"
    class='form-control'
    [ngClass]="{ 'ba-error': isInvalid }"
    [attr.data-has-error]="hasError"
    [attr.data-error-message]="control.errors?.message"
    [attr.data-error-label]="errorLabel"
    [name]='name'
    [maxLength]="10"
    [placeholder]='placeholder'
    (blur)="onBlur()"
    [(ngModel)]="value">
  @if (isInvalid) {
    <wba-error-message
      _id="{{id}}"
      [control]="control"/>
  }
}
